// import uploadVideo from "../assets/images/uploadVideo.svg";
import infoIcon from "../assets/images/info.svg";
import { pageLocale } from "./locale";
const { how_to_test } = pageLocale("testinfo");
const { test_guide, general_guide, female, male, other } = pageLocale("common");
export const ageList = [
  { title: "< 40", value: "< 40" },
  { title: "50 - 60", value: "50 - 60" },
  { title: "40 - 50", value: "40 - 50" },
  { title: "60 >", value: "60 >" },
];

export const genderList = [
  { title: female, value: "Female" },
  { title: male, value: "Male" },
  { title: other, value: "Other" },
];

export const infoPageItem = [
  {
    icon: infoIcon,
    title: how_to_test,
  },
  // {
  //   icon: uploadVideo,
  //   title: upload_video,
  // },
];

export const romplaylistItem = [
  {
    title: `1. ${test_guide}`,
    urlEN: `https://youtu.be/TY6_mNvi8pw`,
    urlJP: `https://youtu.be/TX9OpYdO0o0`,
  },
  {
    title: `2. ${general_guide}`,
    urlEN: `https://youtu.be/Qb3T992cBRg`,
    urlJP: `https://youtu.be/O3FCaxYYFN0`,
  },
];
